import { useState, useContext } from 'react'
import { Handle, Position, useReactFlow } from '@xyflow/react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import Settings from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";


function WorkflowLoopNode({ id, data }) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function setActiveEditLoopNode() {
        const node = reactFlowInstance.getNode(id);
        context.setActiveEditLoopNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node loop-condition " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="loop-condition-input-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <Handle
                type="source"
                position={Position.Left}
                id="loop-condition-output-source"
            >
                <span className="handle-label left" >{ "Loop Out" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className="loop-icon" />
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Loop Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ setActiveEditLoopNode }>
                        <Settings />
                    </span>
                </div>
            </div>
            <Handle
                type="source"
                position={Position.Right}
                id="loop-condition-loop-exit-source"
            >
                <span className="handle-label right" >{ "Exit" }</span>
            </Handle>

            <Handle type="target" id="loop-condition-loop-in-target" position={Position.Bottom} >
                <span className="handle-label bottom" >{ "Loop In" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowLoopNode;